import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onUpdate:modelValue", "type", "id"]
const _hoisted_3 = ["onUpdate:modelValue", "id"]
const _hoisted_4 = {
  key: 1,
  class: "error"
}
const _hoisted_5 = { class: "form-actions" }
const _hoisted_6 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers($setup.handleSubmit, ["prevent"])
  }, [
    ($props.schema && $props.schema[$props.entityType] && $props.schema[$props.entityType].fields)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.schema[$props.entityType].fields, (field) => {
            return (_openBlock(), _createBlock($setup["FormGroup"], {
              key: field.name,
              label: field.label,
              for: field.name,
              description: field.description
            }, {
              default: _withCtx(() => [
                (field.type !== 'textarea')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      "onUpdate:modelValue": $event => (($setup.formData[field.name]) = $event),
                      type: field.type,
                      id: field.name
                    }, null, 8 /* PROPS */, _hoisted_2)), [
                      [_vModelDynamic, $setup.formData[field.name]]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 1,
                      "onUpdate:modelValue": $event => (($setup.formData[field.name]) = $event),
                      id: field.name,
                      rows: "4"
                    }, null, 8 /* PROPS */, _hoisted_3)), [
                      [_vModelText, $setup.formData[field.name]]
                    ])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "for", "description"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "ERROR: Cannot find fields for entityType: " + _toDisplayString($props.entityType), 1 /* TEXT */)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "submit",
        disabled: $setup.store.loading
      }, _toDisplayString($props.submitText), 9 /* TEXT, PROPS */, _hoisted_6)
    ])
  ], 32 /* NEED_HYDRATION */))
}